<template>
  <KPaginatedAutocomplete :paginator="autocomplete" v-bind="$attrs" v-on="$listeners" ref="autocomplete"/>
</template>

<script>
import { autocomplete } from '@/api/endpoints/microservice.js';
import KPaginatedAutocomplete from '@/components/crud/fields/KPaginatedAutocomplete.vue';

export default {
  name: 'MicroserviceAutocomplete',
  components: { KPaginatedAutocomplete },
  methods: {
    autocomplete(page, perPage, search, sortBy, descending, params) {
      return autocomplete(page, perPage, search, sortBy, descending, params);
    },
  },
};
</script>
